import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef} from '@angular/core';
import {o, OdataQuery} from "odata";
import {FilterComponent} from "../filter/filter.component";
import {FilterSettings, FilterOption, FilterUtils} from "../filter";

@Component({
    selector: 'date-filter',
    templateUrl: './date-filter.component.html'
})
export class DateFilterComponent extends FilterComponent {

    @ViewChild('input1')
    firstInput: ElementRef<HTMLInputElement>;

    @ViewChild('input2')
    secondInput: ElementRef<HTMLInputElement>;
    
    public Options: FilterOption[] = [
        {
            Name: 'Is',
            FilterClauseFormat: '{{0}} eq {1}'
        },
        {
            Name: 'Is Not',
            FilterClauseFormat: '{{0}} ne {1}'
        },
        {
            Name: 'Is After',
            FilterClauseFormat: '{{0}} gt {1}'
        },
        {
            Name: 'Is Before',
            FilterClauseFormat: '{{0}} lt {1}'
        },
        {
            Name: 'Is On Or After',
            FilterClauseFormat: '{{0}} ge {1}'
        },
        {
            Name: 'Is On Or Before',
            FilterClauseFormat: '{{0}} le {1}'
        },
        {
            Name: 'Is Between',
            FilterClauseFormat: '{{0}} ge {1} and {{0}} le {2}'
        }
    ];
    
    public SelectedOption: FilterOption;
    
    public Value1: Date;
    public Value2: Date;
    
    constructor() {
        super();
    }
    
    ngOnInit() {
        if (this.FilterSettings) {
            this.SelectedOption = this.FilterSettings.FilterModel.Option;
            this.Value1 = this.FilterSettings.FilterModel.Value1;
            this.Value2 = this.FilterSettings.FilterModel.Value2;
        }
        else {
            this.SelectedOption = this.Options[0];
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.firstInput.nativeElement.focus();
        }, 50);
    }

    FirstInputComplete() {
        if (this.SelectedOption && this.SelectedOption.Name == 'Is Between') {
            this.secondInput.nativeElement.focus();
        }
        else {
            this.FilterInputComplete.emit();
        }
    }

    updateFilterSettings() {
        this.FilterSettingsChange.emit(new FilterSettings(
            FilterUtils.format(
                this.SelectedOption.FilterClauseFormat,
                '0',
                this.Value1,
                this.Value2),
            {
                Option: this.SelectedOption,
                Value1: this.Value1,
                Value2: this.Value2
            }
        ));
    }
}
